import swiperPropertyItem from "./swipers/swiperPropertyItem";
import swiperPropertyQuickView from "./swipers/swiperPropertyQuickView";
import swiperPropertySingle from "./swipers/swiperPropertySingle";
import swiperPropertyListing from "./swipers/swiperPropertyListing";
import swiperPropertyGalleryGrid from "./swipers/swiperPropertyGalleryGrid";
import swiperMapLocations from "./swipers/swiperMapLocations";
import swiperCollections from "./swipers/swiperCollections";
import swiperTeamMembers from "./swipers/swiperTeamMembers";
import swiperPostsCarousel from "./swipers/swiperPostsCarousel";
import swiperImageCardsGrid from "./swipers/swiperImageCardsGrid";

export default function initSwipers() {
    swiperPropertyItem();
    swiperPropertyQuickView();
    swiperPropertySingle();
    swiperPropertyListing();
    swiperPropertyGalleryGrid();
    swiperMapLocations();
    swiperCollections();
    swiperTeamMembers();
    swiperPostsCarousel();
    swiperImageCardsGrid();
}
